<template>
  <div>
    <div class="row" v-if="!loading">
      <div
        id="panel-template"
        class="panel-template"
        :class="panelLeft"
        :style="{
          backgroundColor:
            action.email.template.scale !== 'colors' &&
            action.email.template.scale !== 'fixedColors'
              ? action.email.template.background
              : '#ffffff',
        }"
      >
        <div
          v-if="action.useLogo && action.channel !== 'widget'"
          class="template-header"
        >
          <img :src="action.uploadedImage ? action.uploadedImage : logo" />
        </div>
        <div v-show="country === 'br'" class="template-body">
          <wysiwyg
            api-key="no-api-key"
            license_key="gpl2"
            tinymceScriptSrc="https://tinymce5.s3.amazonaws.com/tinymce/tinymce.min.js"
            :init="{
              menubar: false,
              statusbar: false,
              height: 600,
              language: $t('newAction.stepOne.editorLanguage'),
              plugins: 'link image lists hr emoticons',
              toolbar:
                'bold italic underline | alignleft aligncenter alignright alignjustify | link image | forecolor backcolor | bullist numlist | fontselect fontsizeselect formatselect | emoticons | hr | lineheight | code | styleselect',
              lineheight_formats: '1 1.1 1.2 1.3 1.4 1.5 2',
              fontsize_formats: '8pt 10pt 12pt 14pt 16pt 18pt 24pt 36pt',
              content_style: `
            @import url(https://fonts.googleapis.com/css2?family=Lato:wght@400;500;600;900&display=swap);
          `,
              style_formats: [
                { title: 'Fontes customizada', format: 'p', disabled: true },
                {
                  title: 'Lato Regular',
                  inline: 'span',
                  styles: {
                    fontFamily: 'Lato',
                    fontWeight: '400',
                    fontStyle: 'normal',
                  },
                },
                {
                  title: 'Lato Medium',
                  inline: 'span',
                  styles: {
                    fontFamily: 'Lato',
                    fontWeight: '600',
                    fontStyle: 'normal',
                  },
                },
                {
                  title: 'Lato Bold',
                  inline: 'span',
                  styles: {
                    fontFamily: 'Lato',
                    fontWeight: '900',
                    fontStyle: 'normal',
                  },
                },
              ],
              font_formats:
                'Andale Mono=andale mono,times; Arial=arial,helvetica,sans-serif; Arial Black=arial black,avant garde; Book Antiqua=book antiqua,palatino; Comic Sans MS=comic sans ms,sans-serif; Courier New=courier new,courier; Georgia=georgia,palatino; Helvetica=helvetica; Impact=impact,chicago; Lato=Lato;Roboto=Roboto, sans-serif;Tahoma=tahoma,arial,helvetica,sans-serif; Terminal=terminal,monaco; Times New Roman=times new roman,times; Trebuchet MS=trebuchet ms,geneva; Verdana=verdana,geneva; Webdings=webdings; Wingdings=wingdings,zapf dingbats',
              image_description: false,
              image_title: false,
              content_style: 'img {max-width: 100%; max-height: 100%}',
              image_dimensions: false,
              file_picker_types: 'image',
              content_style:
                '@import url(https://fonts.googleapis.com/css2?family=Roboto, sans-serif&display=swap);',
              images_upload_handler: imagesUploadHandlerBody,
              file_picker_callback: function (cb, value, meta) {
                uploadImgTinyMce(cb);
              },
            }"
            v-if="panelLeft === 'col-8'"
            v-model="action.email.template.myHTML"
          />
          <div
            :style="{
              backgroundColor:
                action.email.template.scale !== 'colors' &&
                action.email.template.scale !== 'fixedColors'
                  ? action.email.template.background
                  : '#ffffff',
            }"
            v-show="noEditor"
            id="body-email"
            class="no-editor"
            v-html="action.email.template.myHTML"
          ></div>
          <!-- <div class="text-center">
            <p>{{ action.question }}</p>
          </div> -->
        </div>

        <div v-show="country === 'us'" class="template-body">
          <wysiwyg
            apiKey="5p8hpkdu1w9a4ee6gwi8ikn5wwvt5lbxwwhaeamvlwo3lg48"
            :init="{
              menubar: false,
              statusbar: false,
              height: 600,
              language: $t('newAction.stepOne.editorLanguage'),
              plugins: 'link image lists hr emoticons',
              toolbar:
                'bold italic underline | alignleft aligncenter alignright alignjustify | link image | forecolor backcolor | bullist numlist | fontselect fontsizeselect formatselect | emoticons | hr | lineheight | code | styleselect',
              lineheight_formats: '1 1.1 1.2 1.3 1.4 1.5 2',
              fontsize_formats: '8pt 10pt 12pt 14pt 16pt 18pt 24pt 36pt',
              font_formats:
                'Andale Mono=andale mono,times; Arial=arial,helvetica,sans-serif; Arial Black=arial black,avant garde; Book Antiqua=book antiqua,palatino; Comic Sans MS=comic sans ms,sans-serif; Courier New=courier new,courier; Georgia=georgia,palatino; Helvetica=helvetica; Impact=impact,chicago; Lato=Lato;Roboto=Roboto, sans-serif;Tahoma=tahoma,arial,helvetica,sans-serif; Terminal=terminal,monaco; Times New Roman=times new roman,times; Trebuchet MS=trebuchet ms,geneva; Verdana=verdana,geneva; Webdings=webdings; Wingdings=wingdings,zapf dingbats',
              image_description: false,
              image_title: false,
              content_style: 'img {max-width: 100%; max-height: 100%}',
              image_dimensions: false,
              file_picker_types: 'image',
              content_style:
                '@import url(https://fonts.googleapis.com/css2?family=Roboto, sans-serif&display=swap);',
              style_formats: [
                { title: 'Fontes customizada', format: 'p', disabled: true },
                {
                  title: 'Lato Regular',
                  inline: 'span',
                  styles: {
                    fontFamily: 'Lato',
                    fontWeight: '400',
                    fontStyle: 'normal',
                  },
                },
                {
                  title: 'Lato Medium',
                  inline: 'span',
                  styles: {
                    fontFamily: 'Lato',
                    fontWeight: '600',
                    fontStyle: 'normal',
                  },
                },
                {
                  title: 'Lato Bold',
                  inline: 'span',
                  styles: {
                    fontFamily: 'Lato',
                    fontWeight: '900',
                    fontStyle: 'normal',
                  },
                },
              ],
              images_upload_handler: imagesUploadHandlerBody,
              file_picker_callback: function (cb, value, meta) {
                uploadImgTinyMce(cb);
              },
            }"
            v-if="panelLeft === 'col-8'"
            v-model="action.email.template.myHTMLEn"
          />
          <div
            v-show="noEditor"
            id="body-email"
            class="no-editor"
            v-html="action.email.template.myHTMLEn"
          ></div>
          <!-- <div class="text-center">
            <p>{{ action.question }}</p>
          </div> -->
        </div>

        <div v-show="country === 'es'" class="template-body">
          <wysiwyg
            apiKey="5p8hpkdu1w9a4ee6gwi8ikn5wwvt5lbxwwhaeamvlwo3lg48"
            :init="{
              menubar: false,
              statusbar: false,
              height: 600,
              language: $t('newAction.stepOne.editorLanguage'),
              plugins: 'link image lists hr emoticons',
              toolbar:
                'bold italic underline | alignleft aligncenter alignright alignjustify | link image | forecolor backcolor | bullist numlist | fontselect fontsizeselect formatselect | emoticons | hr | lineheight | code | styleselect',
              lineheight_formats: '1 1.1 1.2 1.3 1.4 1.5 2',
              fontsize_formats: '8pt 10pt 12pt 14pt 16pt 18pt 24pt 36pt',
              font_formats:
                'Andale Mono=andale mono,times; Arial=arial,helvetica,sans-serif; Arial Black=arial black,avant garde; Book Antiqua=book antiqua,palatino; Comic Sans MS=comic sans ms,sans-serif; Courier New=courier new,courier; Georgia=georgia,palatino; Helvetica=helvetica; Impact=impact,chicago; Lato=Lato;Roboto=Roboto, sans-serif;Tahoma=tahoma,arial,helvetica,sans-serif; Terminal=terminal,monaco; Times New Roman=times new roman,times; Trebuchet MS=trebuchet ms,geneva; Verdana=verdana,geneva; Webdings=webdings; Wingdings=wingdings,zapf dingbats',
              image_description: false,
              image_title: false,
              content_style: 'img {max-width: 100%; max-height: 100%}',
              image_dimensions: false,
              file_picker_types: 'image',
              content_style:
                '@import url(https://fonts.googleapis.com/css2?family=Roboto, sans-serif&display=swap);',
              style_formats: [
                { title: 'Fontes customizada', format: 'p', disabled: true },
                {
                  title: 'Lato Regular',
                  inline: 'span',
                  styles: {
                    fontFamily: 'Lato',
                    fontWeight: '400',
                    fontStyle: 'normal',
                  },
                },
                {
                  title: 'Lato Medium',
                  inline: 'span',
                  styles: {
                    fontFamily: 'Lato',
                    fontWeight: '600',
                    fontStyle: 'normal',
                  },
                },
                {
                  title: 'Lato Bold',
                  inline: 'span',
                  styles: {
                    fontFamily: 'Lato',
                    fontWeight: '900',
                    fontStyle: 'normal',
                  },
                },
              ],
              images_upload_handler: imagesUploadHandlerBody,
              file_picker_callback: function (cb, value, meta) {
                uploadImgTinyMce(cb);
              },
            }"
            v-if="panelLeft === 'col-8'"
            v-model="action.email.template.myHTMLEs"
          />
          <div
            v-show="noEditor"
            id="body-email"
            class="no-editor"
            v-html="action.email.template.myHTMLEs"
          ></div>
          <!-- <div class="text-center">
            <p>{{ action.question }}</p>
          </div> -->
        </div>

        <div v-show="country === 'br'" class="template-body">
          <wysiwyg
            apiKey="5p8hpkdu1w9a4ee6gwi8ikn5wwvt5lbxwwhaeamvlwo3lg48"
            :init="{
              menubar: false,
              statusbar: false,
              height: 200,
              language: $t('newAction.stepOne.editorLanguage'),
              toolbar:
                'bold italic underline | alignleft aligncenter alignright alignjustify | forecolor | fontselect fontsizeselect | styleselect',
              lineheight_formats: '1 1.1 1.2 1.3 1.4 1.5 2',
              fontsize_formats: '8pt 10pt 12pt 14pt 16pt 18pt 24pt 36pt',
              font_formats:
                'Andale Mono=andale mono,times; Arial=arial,helvetica,sans-serif; Arial Black=arial black,avant garde; Book Antiqua=book antiqua,palatino; Comic Sans MS=comic sans ms,sans-serif; Courier New=courier new,courier; Georgia=georgia,palatino; Helvetica=helvetica; Impact=impact,chicago; Lato=Lato; Roboto=Roboto, sans-serif; Tahoma=tahoma,arial,helvetica,sans-serif; Terminal=terminal,monaco; Times New Roman=times new roman,times; Trebuchet MS=trebuchet ms,geneva; Verdana=verdana,geneva; Webdings=webdings; Wingdings=wingdings,zapf dingbats',
              image_description: false,
              image_title: false,
              content_style:
                'img {max-width: 100%; max-height: 100%}, @import url(https://fonts.googleapis.com/css2?family=Roboto, sans-serif&display=swap);',
              style_formats: [
                { title: 'Fontes customizada', format: 'p', disabled: true },
                {
                  title: 'Lato Regular',
                  inline: 'span',
                  styles: {
                    fontFamily: 'Lato',
                    fontWeight: '400',
                    fontStyle: 'normal',
                  },
                },
                {
                  title: 'Lato Medium',
                  inline: 'span',
                  styles: {
                    fontFamily: 'Lato',
                    fontWeight: '600',
                    fontStyle: 'normal',
                  },
                },
                {
                  title: 'Lato Bold',
                  inline: 'span',
                  styles: {
                    fontFamily: 'Lato',
                    fontWeight: '900',
                    fontStyle: 'normal',
                  },
                },
              ],
              image_dimensions: false,
            }"
            v-if="panelLeft === 'col-8'"
            v-model="questionHTML"
          />
          <div
            :style="{
              backgroundColor:
                action.email.template.scale !== 'colors' &&
                action.email.template.scale !== 'fixedColors'
                  ? action.email.template.background
                  : '#ffffff',
            }"
            v-show="noEditor"
            id="body-email"
            class="no-editor"
            v-html="questionHTML"
          ></div>
        </div>

        <div v-show="country === 'us'" class="template-body">
          <wysiwyg
            apiKey="5p8hpkdu1w9a4ee6gwi8ikn5wwvt5lbxwwhaeamvlwo3lg48"
            :init="{
              menubar: false,
              statusbar: false,
              height: 200,
              language: $t('newAction.stepOne.editorLanguage'),
              toolbar:
                'bold italic underline | alignleft aligncenter alignright alignjustify | forecolor | fontselect fontsizeselect | styleselect',
              lineheight_formats: '1 1.1 1.2 1.3 1.4 1.5 2',
              fontsize_formats: '8pt 10pt 12pt 14pt 16pt 18pt 24pt 36pt',
              font_formats:
                'Andale Mono=andale mono,times; Arial=arial,helvetica,sans-serif; Arial Black=arial black,avant garde; Book Antiqua=book antiqua,palatino; Comic Sans MS=comic sans ms,sans-serif; Courier New=courier new,courier; Georgia=georgia,palatino; Helvetica=helvetica; Impact=impact,chicago; Lato=Lato; Roboto=Roboto, sans-serif; Tahoma=tahoma,arial,helvetica,sans-serif; Terminal=terminal,monaco; Times New Roman=times new roman,times; Trebuchet MS=trebuchet ms,geneva; Verdana=verdana,geneva; Webdings=webdings; Wingdings=wingdings,zapf dingbats',
              image_description: false,
              image_title: false,
              content_style:
                'img {max-width: 100%; max-height: 100%}, @import url(https://fonts.googleapis.com/css2?family=Roboto, sans-serif&display=swap);',
              style_formats: [
                { title: 'Fontes customizada', format: 'p', disabled: true },
                {
                  title: 'Lato Regular',
                  inline: 'span',
                  styles: {
                    fontFamily: 'Lato',
                    fontWeight: '400',
                    fontStyle: 'normal',
                  },
                },
                {
                  title: 'Lato Medium',
                  inline: 'span',
                  styles: {
                    fontFamily: 'Lato',
                    fontWeight: '600',
                    fontStyle: 'normal',
                  },
                },
                {
                  title: 'Lato Bold',
                  inline: 'span',
                  styles: {
                    fontFamily: 'Lato',
                    fontWeight: '900',
                    fontStyle: 'normal',
                  },
                },
              ],
              image_dimensions: false,
            }"
            v-if="panelLeft === 'col-8'"
            v-model="questionHTMLEn"
          />
          <div
            v-show="noEditor"
            id="body-email"
            class="no-editor"
            v-html="questionHTMLEn"
          ></div>
        </div>

        <div v-show="country === 'es'" class="template-body">
          <wysiwyg
            apiKey="5p8hpkdu1w9a4ee6gwi8ikn5wwvt5lbxwwhaeamvlwo3lg48"
            :init="{
              menubar: false,
              statusbar: false,
              height: 200,
              language: $t('newAction.stepOne.editorLanguage'),
              toolbar:
                'bold italic underline | alignleft aligncenter alignright alignjustify | forecolor | fontselect fontsizeselect | styleselect',
              lineheight_formats: '1 1.1 1.2 1.3 1.4 1.5 2',
              fontsize_formats: '8pt 10pt 12pt 14pt 16pt 18pt 24pt 36pt',
              font_formats:
                'Andale Mono=andale mono,times; Arial=arial,helvetica,sans-serif; Arial Black=arial black,avant garde; Book Antiqua=book antiqua,palatino; Comic Sans MS=comic sans ms,sans-serif; Courier New=courier new,courier; Georgia=georgia,palatino; Helvetica=helvetica; Impact=impact,chicago; Lato=Lato; Roboto=Roboto, sans-serif; Tahoma=tahoma,arial,helvetica,sans-serif; Terminal=terminal,monaco; Times New Roman=times new roman,times; Trebuchet MS=trebuchet ms,geneva; Verdana=verdana,geneva; Webdings=webdings; Wingdings=wingdings,zapf dingbats',
              image_description: false,
              image_title: false,
              content_style:
                'img {max-width: 100%; max-height: 100%}, @import url(https://fonts.googleapis.com/css2?family=Roboto, sans-serif&display=swap);',
              style_formats: [
                { title: 'Fontes customizada', format: 'p', disabled: true },
                {
                  title: 'Lato Regular',
                  inline: 'span',
                  styles: {
                    fontFamily: 'Lato',
                    fontWeight: '400',
                    fontStyle: 'normal',
                  },
                },
                {
                  title: 'Lato Medium',
                  inline: 'span',
                  styles: {
                    fontFamily: 'Lato',
                    fontWeight: '600',
                    fontStyle: 'normal',
                  },
                },
                {
                  title: 'Lato Bold',
                  inline: 'span',
                  styles: {
                    fontFamily: 'Lato',
                    fontWeight: '900',
                    fontStyle: 'normal',
                  },
                },
              ],
              image_dimensions: false,
            }"
            v-if="panelLeft === 'col-8'"
            v-model="questionHTMLEs"
          />
          <div
            v-show="noEditor"
            id="body-email"
            class="no-editor"
            v-html="questionHTMLEs"
          ></div>
        </div>
        <template
          v-if="action.channel == 'email' || action.channel === 'emailsms' || action.channel === 'email/whatsapp'"
        >
          <div v-if="action.email.template.scaleLayout === 'button'">
            <div class="button-experience">
              <methodology
                :lang="country"
                :templateColor="
                  templateSelected
                    ? templateSelected.scale
                    : templateColorSelected
                "
                :actionMetric="action.type"
              />
            </div>
            <p style="margin-top: 18px; margin-bottom: 0px">
              ** {{ $t('newAction.stepOne.bodyButtonMsg') }}
            </p>
            <div class="button-experience">
              <button
                class="rate-experience"
                :style="{
                  backgroundColor: action.email.template.button,
                  borderColor: action.email.template.button,
                  color: action.email.template.grade,
                }"
              >
                {{ $t('newAction.stepOne.rateExperience') }}
              </button>
            </div>
          </div>
          <div v-else>
            <div class="template-methodology">
              <methodology
                :lang="country"
                :templateColor="
                  templateSelected
                    ? templateSelected.scale
                    : templateColorSelected
                "
                :actionMetric="action.type"
              />
            </div>
          </div>
        </template>
        <template v-else>
          <div class="template-methodology">
            <methodology
              :lang="country"
              :templateColor="
                templateSelected
                  ? templateSelected.scale
                  : templateColorSelected
              "
              :actionMetric="action.type"
            />
          </div>
        </template>
        <div class="footer-content" v-if="action.footerEnabled">
          <div v-show="country === 'br'">
            <wysiwyg
              apiKey="5p8hpkdu1w9a4ee6gwi8ikn5wwvt5lbxwwhaeamvlwo3lg48"
              :init="{
                selector: 'wysiwyg',
                menubar: false,
                statusbar: false,
                language: this.$t('newAction.stepOne.editorLanguage'),
                plugins: 'link image lists hr emoticons',
                toolbar:
                  'bold italic underline | alignleft aligncenter alignright alignjustify | link image | code | forecolor backcolor | bullist numlist | fontselect fontsizeselect formatselect | emoticons | hr | lineheight | styleselect ',
                lineheight_formats: '1 1.1 1.2 1.3 1.4 1.5 2',
                fontsize_formats: '8pt 10pt 12pt 14pt 16pt 18pt 24pt 36pt',
                font_formats:
                  'Andale Mono=andale mono,times; Arial=arial,helvetica,sans-serif; Arial Black=arial black,avant garde; Book Antiqua=book antiqua,palatino; Comic Sans MS=comic sans ms,sans-serif; Courier New=courier new,courier; Georgia=georgia,palatino; Helvetica=helvetica; Impact=impact,chicago; Lato=Lato; Roboto=Roboto, sans-serif; Tahoma=tahoma,arial,helvetica,sans-serif; Terminal=terminal,monaco; Times New Roman=times new roman,times; Trebuchet MS=trebuchet ms,geneva; Verdana=verdana,geneva; Webdings=webdings; Wingdings=wingdings,zapf dingbats',
                image_description: false,
                image_title: false,
                content_style:
                  'img {max-width: 100%; max-height: 100%}, @import url(https://fonts.googleapis.com/css2?family=Roboto, sans-serif&display=swap);',
                style_formats: [
                  { title: 'Fontes customizada', format: 'p', disabled: true },
                  {
                    title: 'Lato Regular',
                    inline: 'span',
                    styles: {
                      fontFamily: 'Lato',
                      fontWeight: '400',
                      fontStyle: 'normal',
                    },
                  },
                  {
                    title: 'Lato Medium',
                    inline: 'span',
                    styles: {
                      fontFamily: 'Lato',
                      fontWeight: '600',
                      fontStyle: 'normal',
                    },
                  },
                  {
                    title: 'Lato Bold',
                    inline: 'span',
                    styles: {
                      fontFamily: 'Lato',
                      fontWeight: '900',
                      fontStyle: 'normal',
                    },
                  },
                ],
                image_dimensions: false,
                file_picker_types: 'image',
                images_upload_handler: imagesUploadHandlerFooter,
                file_picker_callback: function (cb, value, meta) {
                  uploadImgTinyMce(cb);
                },
              }"
              v-if="panelLeft === 'col-8'"
              v-model="action.footerContent"
            />
            <span v-else class="no-editor" v-html="action.footerContent" />
          </div>
          <div v-show="country === 'us'">
            <wysiwyg
              apiKey="5p8hpkdu1w9a4ee6gwi8ikn5wwvt5lbxwwhaeamvlwo3lg48"
              :init="{
                selector: 'wysiwyg',
                menubar: false,
                statusbar: false,
                language: this.$t('newAction.stepOne.editorLanguage'),
                plugins: 'link image lists hr emoticons',
                toolbar:
                  'bold italic underline | alignleft aligncenter alignright alignjustify | link image | code | forecolor backcolor | bullist numlist | fontselect fontsizeselect formatselect | emoticons | hr | lineheight | styleselect',
                lineheight_formats: '1 1.1 1.2 1.3 1.4 1.5 2',
                fontsize_formats: '8pt 10pt 12pt 14pt 16pt 18pt 24pt 36pt',
                font_formats:
                  'Andale Mono=andale mono,times; Arial=arial,helvetica,sans-serif; Arial Black=arial black,avant garde; Book Antiqua=book antiqua,palatino; Comic Sans MS=comic sans ms,sans-serif; Courier New=courier new,courier; Georgia=georgia,palatino; Helvetica=helvetica; Impact=impact,chicago; Lato=Lato; Roboto=Roboto, sans-serif; Tahoma=tahoma,arial,helvetica,sans-serif; Terminal=terminal,monaco; Times New Roman=times new roman,times; Trebuchet MS=trebuchet ms,geneva; Verdana=verdana,geneva; Webdings=webdings; Wingdings=wingdings,zapf dingbats',
                image_description: false,
                image_title: false,
                content_style:
                  'img {max-width: 100%; max-height: 100%}, @import url(https://fonts.googleapis.com/css2?family=Roboto, sans-serif&display=swap);',
                style_formats: [
                  { title: 'Fontes customizada', format: 'p', disabled: true },
                  {
                    title: 'Lato Regular',
                    inline: 'span',
                    styles: {
                      fontFamily: 'Lato',
                      fontWeight: '400',
                      fontStyle: 'normal',
                    },
                  },
                  {
                    title: 'Lato Medium',
                    inline: 'span',
                    styles: {
                      fontFamily: 'Lato',
                      fontWeight: '600',
                      fontStyle: 'normal',
                    },
                  },
                  {
                    title: 'Lato Bold',
                    inline: 'span',
                    styles: {
                      fontFamily: 'Lato',
                      fontWeight: '900',
                      fontStyle: 'normal',
                    },
                  },
                ],
                image_dimensions: false,
                file_picker_types: 'image',
                images_upload_handler: imagesUploadHandlerFooter,
                file_picker_callback: function (cb, value, meta) {
                  uploadImgTinyMce(cb);
                },
              }"
              v-if="panelLeft === 'col-8'"
              v-model="footerContentEn"
            />
            <span v-else class="no-editor" v-html="footerContentEn" />
          </div>
          <div v-show="country === 'es'">
            <wysiwyg
              apiKey="5p8hpkdu1w9a4ee6gwi8ikn5wwvt5lbxwwhaeamvlwo3lg48"
              :init="{
                selector: 'wysiwyg',
                menubar: false,
                statusbar: false,
                language: this.$t('newAction.stepOne.editorLanguage'),
                plugins: 'link image lists hr emoticons',
                toolbar:
                  'bold italic underline | alignleft aligncenter alignright alignjustify | link image | code | forecolor backcolor | bullist numlist | fontselect fontsizeselect formatselect | emoticons | hr | lineheight | styleselect',
                lineheight_formats: '1 1.1 1.2 1.3 1.4 1.5 2',
                fontsize_formats: '8pt 10pt 12pt 14pt 16pt 18pt 24pt 36pt',
                font_formats:
                  'Andale Mono=andale mono,times; Arial=arial,helvetica,sans-serif; Arial Black=arial black,avant garde; Book Antiqua=book antiqua,palatino; Comic Sans MS=comic sans ms,sans-serif; Courier New=courier new,courier; Georgia=georgia,palatino; Helvetica=helvetica; Impact=impact,chicago; Lato=Lato; Roboto=Roboto, sans-serif; Tahoma=tahoma,arial,helvetica,sans-serif; Terminal=terminal,monaco; Times New Roman=times new roman,times; Trebuchet MS=trebuchet ms,geneva; Verdana=verdana,geneva; Webdings=webdings; Wingdings=wingdings,zapf dingbats',
                image_description: false,
                image_title: false,
                content_style:
                  'img {max-width: 100%; max-height: 100%}, @import url(https://fonts.googleapis.com/css2?family=Roboto, sans-serif&display=swap);',
                style_formats: [
                  { title: 'Fontes customizada', format: 'p', disabled: true },
                  {
                    title: 'Lato Regular',
                    inline: 'span',
                    styles: {
                      fontFamily: 'Lato',
                      fontWeight: '400',
                      fontStyle: 'normal',
                    },
                  },
                  {
                    title: 'Lato Medium',
                    inline: 'span',
                    styles: {
                      fontFamily: 'Lato',
                      fontWeight: '600',
                      fontStyle: 'normal',
                    },
                  },
                  {
                    title: 'Lato Bold',
                    inline: 'span',
                    styles: {
                      fontFamily: 'Lato',
                      fontWeight: '900',
                      fontStyle: 'normal',
                    },
                  },
                ],
                image_dimensions: false,
                file_picker_types: 'image',
                images_upload_handler: imagesUploadHandlerFooter,
                file_picker_callback: function (cb, value, meta) {
                  uploadImgTinyMce(cb);
                },
              }"
              v-if="panelLeft === 'col-8'"
              v-model="footerContentEs"
            />
            <span v-else class="no-editor" v-html="footerContentEs" />
          </div>
        </div>
        <div
          class="template-footer"
          v-if="action.email.template.footer && action.channel !== 'widget'"
        >
          <img src="../../../../assets/logo-indecx.png" />
        </div>
        <div
          class="template-disclaimer"
          v-if="action.enableAnonymous || action.allAnswersAnonymous"
        >
          <div v-show="country === 'br'">
            <input
              type="text"
              class="form-control"
              v-if="panelLeft === 'col-8'"
              v-model="action.enableAnonymous"
            />
            <span v-else>
              <a
                :style="{
                  color:
                    action.email.template.scale !== 'colors' &&
                    action.email.template.scale !== 'fixedColors'
                      ? action.email.template.backgroundtext
                      : '#000000',
                }"
              >
                {{ action.enableAnonymous }}
              </a>
            </span>
          </div>
          <div v-show="country === 'us'">
            <input
              type="text"
              class="form-control"
              v-if="panelLeft === 'col-8'"
              v-model="action.enableAnonymousEn"
            />
            <span v-else>
              <a
                :style="{
                  color:
                    action.email.template.scale !== 'colors' &&
                    action.email.template.scale !== 'fixedColors'
                      ? action.email.template.backgroundtext
                      : '#000000',
                }"
              >
                {{ action.enableAnonymousEn }}
              </a>
            </span>
          </div>
          <div v-show="country === 'es'">
            <input
              type="text"
              class="form-control"
              v-if="panelLeft === 'col-8'"
              v-model="action.enableAnonymousEs"
            />
            <span v-else>
              country
              <a
                :style="{
                  color:
                    action.email.template.scale !== 'colors' &&
                    action.email.template.scale !== 'fixedColors'
                      ? action.email.template.backgroundtext
                      : '#000000',
                }"
              >
                {{ action.enableAnonymousEs }}
              </a>
            </span>
          </div>
        </div>
        <div class="template-disclaimer" v-if="action.privacyPolicy">
          <div v-show="$i18n.locale === 'br'">
            <input
              type="text"
              class="form-control"
              v-if="panelLeft === 'col-8'"
              v-model="privacyPolicy"
            />
            <span v-else>
              <a :href="company.privacyPolicy" target="_blank">
                {{ privacyPolicy }}
              </a>
            </span>
          </div>
          <div v-show="$i18n.locale === 'us'">
            <input
              type="text"
              class="form-control"
              v-if="panelLeft === 'col-8'"
              v-model="privacyPolicyEn"
            />
            <span v-else>
              <a :href="company.privacyPolicy" target="_blank">
                {{ privacyPolicyEn }}
              </a>
            </span>
          </div>
          <div v-show="$i18n.locale === 'es'">
            <input
              type="text"
              class="form-control"
              v-if="panelLeft === 'col-8'"
              v-model="privacyPolicyEs"
            />
            <span v-else>
              <a :href="company.privacyPolicy" target="_blank">
                {{ privacyPolicyEs }}
              </a>
            </span>
          </div>
        </div>
      </div>
      <div id="config-template" class="config-template" :class="panelRight">
        <div id="btn-actions" class="btn-actions">
          <button
            :title="`${this.$t('newAction.stepOne.editButton')}`"
            class="btn btn-primary"
            v-if="showPen"
            @click="expandPanel"
          >
            <font-awesome-icon :icon="['fas', 'pen']" />
          </button>
          <button
            v-if="showReturn"
            :title="`${this.$t('newAction.buttonReturn')}`"
            class="btn btn-primary"
            @click="returnPanel"
          >
            <i class="fas fa-arrow-left"></i>
          </button>
          <router-link
            v-if="action.channel !== 'widget'"
            :to="`/email/preview`"
            class="preview"
          >
            <button
              :title="`${this.$t('newAction.stepOne.preview')}`"
              class="btn btn-primary btn-view"
              @click="checkPreview"
            >
              <font-awesome-icon
                :icon="['fas', 'eye']"
                style="font-size: 16px; margin-left: -2px"
              />
            </button>
          </router-link>
          <modal-test-survey-email
            v-if="action.channel !== 'widget' && action.channel !== 'qrcode'"
          />
        </div>
        <transition name="fade">
          <div v-if="panelOptions">
            <div
              class="form-group"
              v-if="action.channel !== 'widget' && action.channel !== 'qrcode'"
            >
              <input
                id="email-from"
                :placeholder="`${this.$t('newAction.stepOne.sender')}`"
                class="form-control"
                type="text"
                :value="action.email.from"
                @keyup="setEmailFrom($event.target.value)"
              />
              <div class="invalid-feedback">
                {{ $t('newAction.stepOne.feedbackSender') }}
              </div>
            </div>
            <div
              class="form-group"
              v-if="action.channel !== 'widget' && action.channel !== 'qrcode'"
            >
              <input
                id="email-subject"
                :placeholder="`${this.$t('newAction.stepOne.subjectMatter')}`"
                class="form-control"
                type="text"
                :value="action.email.subject"
                @keyup="setEmailSubject($event.target.value)"
              />
              <div class="invalid-feedback">
                {{ $t('newAction.stepOne.enterSubject') }}
              </div>
            </div>
            <div
              v-if="action.channel == 'email' || action.channel === 'emailsms' || action.channel === 'email/whatsapp'"
            >
              <input
                type="text"
                class="form-control input-panel"
                :value="`${$t(
                  'actionTranslateUpdate.templateTranslateRef.templateTitle',
                )}`"
                disabled
              />
              <scaleLayoutOptions />
            </div>
            <input
              type="text"
              class="form-control input-panel"
              :value="`${this.$t('newAction.stepOne.template')}`"
              disabled
            />
            <div>
              <div>
                <buttons-templates />
              </div>
              <div style="display: flex">
                <div
                  v-if="
                    action.email.template.scale !== 'colors' &&
                    action.email.template.scale !== 'fixedColors'
                  "
                  style="display: flex"
                >
                  <label for="pickScale" class="scaleLabel">
                    {{ $t('newAction.stepOne.scaleButton') }}:
                  </label>
                  <verte
                    ref="pickScale"
                    id="pickScale"
                    picker="square"
                    model="hex"
                    v-model="templatescale"
                  >
                  </verte>
                </div>
                <div
                  v-if="
                    action.email.template.scale !== 'colors' &&
                    action.email.template.scale !== 'fixedColors'
                  "
                  style="display: flex; padding-left: 20px"
                >
                  <label for="pickScale" class="scaleLabel">
                    {{ $t('newAction.stepOne.scaleBorder') }}:
                  </label>
                  <verte
                    ref="pickBorder"
                    picker="square"
                    model="hex"
                    v-model="templateborder"
                  >
                  </verte>
                </div>
                <div
                  v-if="
                    (action.email.template.scale !== 'colors' &&
                      action.email.template.scale !== 'fixedColors') ||
                    action.email.template.scaleLayout === 'button'
                  "
                  style="display: flex; padding-left: 20px"
                >
                  <label for="pickGrade" class="scaleLabel">
                    {{ $t('newAction.stepOne.scaleGrade') }}:
                  </label>
                  <verte
                    ref="pickGrade"
                    picker="square"
                    model="hex"
                    v-model="templategrade"
                  >
                  </verte>
                </div>
                <div
                  v-if="action.email.template.scaleLayout === 'button'"
                  style="display: flex; padding-left: 20px"
                >
                  <label for="pickButton" class="scaleLabel">
                    {{ $t('newAction.stepOne.scaleLargeButton') }}:
                  </label>
                  <verte
                    ref="pickButton"
                    picker="square"
                    model="hex"
                    v-model="templatebutton"
                  >
                  </verte>
                </div>
                <div
                  v-if="
                    (action.email.template.scale !== 'colors' &&
                      action.email.template.scale !== 'fixedColors') ||
                    action.email.template.scaleLayout === 'button'
                  "
                  style="display: flex; padding-left: 20px"
                >
                  <label for="pickButton" class="scaleLabel">
                    {{ $t('newAction.stepOne.scaleButtonselected') }}:
                  </label>
                  <verte
                    ref="pickButton"
                    picker="square"
                    model="hex"
                    v-model="templatebuttonselected"
                  >
                  </verte>
                </div>
              </div>
              <div style="display: flex">
                <div
                  v-if="
                    (action.email.template.scale !== 'colors' &&
                      action.email.template.scale !== 'fixedColors') ||
                    action.email.template.scaleLayout === 'button'
                  "
                  style="display: flex"
                >
                  <label for="pickBackground" class="scaleLabel">
                    {{ $t('newAction.stepOne.scaleBackground') }}:
                  </label>
                  <verte
                    ref="pickBackground"
                    picker="square"
                    model="hex"
                    v-model="templatebackground"
                  >
                  </verte>
                </div>
                <div
                  v-if="
                    (action.email.template.scale !== 'colors' &&
                      action.email.template.scale !== 'fixedColors') ||
                    action.email.template.scaleLayout === 'button'
                  "
                  style="display: flex; padding-left: 20px"
                >
                  <label for="pickBackgroundText" class="scaleLabel">
                    {{ $t('newAction.stepOne.scaleBackgroundText') }}:
                  </label>
                  <verte
                    ref="pickBackgroundText"
                    picker="square"
                    model="hex"
                    v-model="templatebackgroundtext"
                  >
                  </verte>
                </div>

                <div
                  v-if="
                    (action.email.template.scale !== 'colors' &&
                      action.email.template.scale !== 'fixedColors') ||
                    action.email.template.scaleLayout === 'button'
                  "
                  style="display: flex; padding-left: 20px"
                >
                  <label for="pickBackgroundText" class="scaleLabel">
                    {{ $t('newAction.stepOne.scaleActiveText') }}:
                  </label>
                  <verte
                    ref="pickBackgroundText"
                    picker="square"
                    model="hex"
                    v-model="templatebuttonselectedtext"
                  >
                  </verte>
                </div>
              </div>
            </div>
            <button
              v-b-modal.new-template
              class="btn btn-primary btn-block btn-sm"
              @click="showEditor"
            >
              {{ $t('newAction.stepOne.buttonAddTemplate') }}
            </button>
            <b-modal
              id="new-template"
              @shown="shown"
              @hide="hide"
              tabindex="-1"
              role="dialog"
              size="xl"
              :cancel-title="`${this.$t('newAction.stepOne.cancelButton')}`"
            >
              <template v-slot:modal-title>
                <font-awesome-icon :icon="['fas', 'edit']" />
                {{ $t('newAction.stepOne.newTemplateEmail') }}
              </template>
              <div class="row">
                <div class="col-12">
                  <div class="col-12">
                    <select
                      @change="modifyTemplate"
                      class="custom-select mb-3"
                      v-model="template"
                    >
                      <option value="0" selected>
                        {{ $t('newAction.stepOne.selectSavedTemplate') }}
                      </option>
                      <option
                        :value="item._id"
                        v-for="(item, index) in list"
                        :key="index"
                      >
                        {{ item.title }}
                      </option>
                    </select>
                  </div>
                  <div v-show="country === 'br'" class="col-12">
                    <wysiwyg
                      v-if="doShow"
                      apiKey="5p8hpkdu1w9a4ee6gwi8ikn5wwvt5lbxwwhaeamvlwo3lg48"
                      :init="{
                        selector: 'wysiwyg',
                        statusbar: false,
                        menubar: false,
                        height: 600,
                        language: this.$t('newAction.stepOne.editorLanguage'),
                        plugins: 'link image lists hr emoticons',
                        toolbar:
                          'bold italic underline | alignleft aligncenter alignright alignjustify | link image | code | forecolor backcolor | bullist numlist | fontselect fontsizeselect formatselect | emoticons | hr | lineheight | styleselect',
                        lineheight_formats: '1 1.1 1.2 1.3 1.4 1.5 2',
                        fontsize_formats:
                          '8pt 10pt 12pt 14pt 16pt 18pt 24pt 36pt',
                        font_formats:
                          'Andale Mono=andale mono,times; Arial=arial,helvetica,sans-serif; Arial Black=arial black,avant garde; Book Antiqua=book antiqua,palatino; Comic Sans MS=comic sans ms,sans-serif; Courier New=courier new,courier; Georgia=georgia,palatino; Helvetica=helvetica; Impact=impact,chicago; Lato=Lato;Roboto=Roboto, sans-serif; Tahoma=tahoma,arial,helvetica,sans-serif; Terminal=terminal,monaco; Times New Roman=times new roman,times; Trebuchet MS=trebuchet ms,geneva; Verdana=verdana,geneva; Webdings=webdings; Wingdings=wingdings,zapf dingbats',
                        image_description: false,
                        image_title: false,
                        content_style:
                          'img {max-width: 100%; max-height: 100%},  @import url(https://fonts.googleapis.com/css2?family=Roboto, sans-serif&display=swap);',
                        style_formats: [
                          {
                            title: 'Fontes customizada',
                            format: 'p',
                            disabled: true,
                          },
                          {
                            title: 'Lato Regular',
                            inline: 'span',
                            styles: {
                              fontFamily: 'Lato',
                              fontWeight: '400',
                              fontStyle: 'normal',
                            },
                          },
                          {
                            title: 'Lato Medium',
                            inline: 'span',
                            styles: {
                              fontFamily: 'Lato',
                              fontWeight: '600',
                              fontStyle: 'normal',
                            },
                          },
                          {
                            title: 'Lato Bold',
                            inline: 'span',
                            styles: {
                              fontFamily: 'Lato',
                              fontWeight: '900',
                              fontStyle: 'normal',
                            },
                          },
                        ],
                        image_dimensions: false,
                        file_picker_types: 'image',
                        images_upload_handler: imagesUploadHandlerBody,
                        file_picker_callback: function (cb, value, meta) {
                          uploadImgTinyMce(cb);
                        },
                      }"
                      v-model="action.email.template.myHTML"
                    />
                  </div>

                  <div v-show="country === 'us'" class="col-12">
                    <wysiwyg
                      v-if="doShow"
                      apiKey="5p8hpkdu1w9a4ee6gwi8ikn5wwvt5lbxwwhaeamvlwo3lg48"
                      :init="{
                        selector: 'wysiwyg',
                        statusbar: false,
                        menubar: false,
                        height: 600,
                        language: this.$t('newAction.stepOne.editorLanguage'),
                        plugins: 'link image lists hr emoticons',
                        toolbar:
                          'bold italic underline | alignleft aligncenter alignright alignjustify | link image | code | forecolor backcolor | bullist numlist | fontselect fontsizeselect formatselect | emoticons | hr | lineheight | styleselect',
                        lineheight_formats: '1 1.1 1.2 1.3 1.4 1.5 2',
                        fontsize_formats:
                          '8pt 10pt 12pt 14pt 16pt 18pt 24pt 36pt',
                        font_formats:
                          'Andale Mono=andale mono,times; Arial=arial,helvetica,sans-serif; Arial Black=arial black,avant garde; Book Antiqua=book antiqua,palatino; Comic Sans MS=comic sans ms,sans-serif; Courier New=courier new,courier; Georgia=georgia,palatino; Helvetica=helvetica; Impact=impact,chicago; Lato=Lato;Roboto=Roboto, sans-serif; Tahoma=tahoma,arial,helvetica,sans-serif; Terminal=terminal,monaco; Times New Roman=times new roman,times; Trebuchet MS=trebuchet ms,geneva; Verdana=verdana,geneva; Webdings=webdings; Wingdings=wingdings,zapf dingbats',
                        image_description: false,
                        image_title: false,
                        content_style:
                          'img {max-width: 100%; max-height: 100%},  @import url(https://fonts.googleapis.com/css2?family=Roboto, sans-serif&display=swap);',
                        style_formats: [
                          {
                            title: 'Fontes customizada',
                            format: 'p',
                            disabled: true,
                          },
                          {
                            title: 'Lato Regular',
                            inline: 'span',
                            styles: {
                              fontFamily: 'Lato',
                              fontWeight: '400',
                              fontStyle: 'normal',
                            },
                          },
                          {
                            title: 'Lato Medium',
                            inline: 'span',
                            styles: {
                              fontFamily: 'Lato',
                              fontWeight: '600',
                              fontStyle: 'normal',
                            },
                          },
                          {
                            title: 'Lato Bold',
                            inline: 'span',
                            styles: {
                              fontFamily: 'Lato',
                              fontWeight: '900',
                              fontStyle: 'normal',
                            },
                          },
                        ],
                        image_dimensions: false,
                        file_picker_types: 'image',
                        images_upload_handler: imagesUploadHandlerBody,
                        file_picker_callback: function (cb, value, meta) {
                          uploadImgTinyMce(cb);
                        },
                      }"
                      v-model="action.email.template.myHTMLEn"
                    />
                  </div>

                  <div v-show="country === 'es'" class="col-12">
                    <wysiwyg
                      v-if="doShow"
                      apiKey="5p8hpkdu1w9a4ee6gwi8ikn5wwvt5lbxwwhaeamvlwo3lg48"
                      :init="{
                        selector: 'wysiwyg',
                        statusbar: false,
                        menubar: false,
                        height: 600,
                        language: this.$t('newAction.stepOne.editorLanguage'),
                        plugins: 'link image lists hr emoticons',
                        toolbar:
                          'bold italic underline | alignleft aligncenter alignright alignjustify | link image | code | forecolor backcolor | bullist numlist | fontselect fontsizeselect formatselect | emoticons | hr | lineheight | styleselect',
                        lineheight_formats: '1 1.1 1.2 1.3 1.4 1.5 2',
                        fontsize_formats:
                          '8pt 10pt 12pt 14pt 16pt 18pt 24pt 36pt',
                        font_formats:
                          'Andale Mono=andale mono,times; Arial=arial,helvetica,sans-serif; Arial Black=arial black,avant garde; Book Antiqua=book antiqua,palatino; Comic Sans MS=comic sans ms,sans-serif; Courier New=courier new,courier; Georgia=georgia,palatino; Helvetica=helvetica; Impact=impact,chicago; Lato=Lato;Roboto=Roboto, sans-serif; Tahoma=tahoma,arial,helvetica,sans-serif; Terminal=terminal,monaco; Times New Roman=times new roman,times; Trebuchet MS=trebuchet ms,geneva; Verdana=verdana,geneva; Webdings=webdings; Wingdings=wingdings,zapf dingbats',
                        image_description: false,
                        image_title: false,
                        content_style:
                          'img {max-width: 100%; max-height: 100%},  @import url(https://fonts.googleapis.com/css2?family=Roboto, sans-serif&display=swap);',
                        style_formats: [
                          {
                            title: 'Fontes customizada',
                            format: 'p',
                            disabled: true,
                          },
                          {
                            title: 'Lato Regular',
                            inline: 'span',
                            styles: {
                              fontFamily: 'Lato',
                              fontWeight: '400',
                              fontStyle: 'normal',
                            },
                          },
                          {
                            title: 'Lato Medium',
                            inline: 'span',
                            styles: {
                              fontFamily: 'Lato',
                              fontWeight: '600',
                              fontStyle: 'normal',
                            },
                          },
                          {
                            title: 'Lato Bold',
                            inline: 'span',
                            styles: {
                              fontFamily: 'Lato',
                              fontWeight: '900',
                              fontStyle: 'normal',
                            },
                          },
                        ],
                        image_dimensions: false,
                        file_picker_types: 'image',
                        images_upload_handler: imagesUploadHandlerBody,
                        file_picker_callback: function (cb, value, meta) {
                          uploadImgTinyMce(cb);
                        },
                      }"
                      v-model="action.email.template.myHTMLEs"
                    />
                  </div>

                  <!--
                  <div class="col-12 mt-2">
                    <b-form-group
                      :label="`${this.$t(
                        'newAction.stepOne.labels.chooseOption',
                      )}`"
                    >
                      <b-form-radio-group
                        id="opt-template-colors"
                        v-model="templateColorSelected"
                        :options="options"
                        name="template-options"
                      ></b-form-radio-group>
                    </b-form-group>
                    <methodology
                      :templateColor="
                        templateSelected
                          ? templateSelected.scale
                          : templateColorSelected
                      "
                      :actionMetric="action.type"
                    />
                  </div>
                  -->
                  <div class="col-12">
                    <b-form inline style="margin-top: 30px">
                      <b-input-group
                        style="width: calc(100% - (68.4833px + 0.5rem))"
                        class="mb-2 mr-sm-2 mb-sm-0"
                      >
                        <b-input
                          id="inline-form-input-template-name"
                          :placeholder="`${this.$t(
                            'newAction.stepOne.enterNameTemplate',
                          )}`"
                          v-model="templateName"
                        ></b-input>
                        <div class="invalid-feedback">
                          {{ $t('newAction.stepOne.feedbackSaveTemplate') }}
                        </div>
                      </b-input-group>
                      <b-button
                        @click="saveTemplate"
                        variant="primary"
                        style="position: absolute; right: 10px; top: 0"
                        >{{ $t('newAction.stepOne.saveButton') }}
                      </b-button>
                    </b-form>
                    <b-alert
                      style="margin-top: 15px"
                      variant="success"
                      dismissible
                      v-model="showDismissibleAlert"
                      >{{ $t('newAction.stepOne.createdSucess') }}</b-alert
                    >
                  </div>
                </div>
              </div>
            </b-modal>

            <div v-if="action.channel !== 'widget'">
              <input
                type="text"
                class="form-control input-panel"
                :value="`${this.$t('newAction.stepOne.topLogo')}`"
                disabled
              />

              <div class="row custom-switch" style="padding-left: 35px">
                <div class="col-12">
                  <input
                    type="checkbox"
                    class="custom-control-input"
                    id="switch-logo"
                    v-model="action.useLogo"
                  />
                  <label class="custom-control-label" for="switch-logo">{{
                    $t('newAction.stepOne.labels.able')
                  }}</label>
                </div>
              </div>

              <input
                type="text"
                class="form-control input-panel"
                :value="`${this.$t('newAction.stepOne.changeLogo')}`"
                v-if="action.useLogo"
                disabled
              />

              <file-input v-if="action.useLogo" />
            </div>

            <input
              v-if="action.channel === 'email' || action.channel === 'emailsms' || action.channel === 'email/whatsapp'"
              type="text"
              class="form-control input-panel"
              value="Layout da pesquisa personalizado(email)"
              disabled
            />
            <div v-if="action.channel !== 'widget'" class="row custom-switch" style="padding-left: 35px">
              <div class="col-12">
                <input
                  type="checkbox"
                  class="custom-control-input"
                  id="switch-template-email-custom"
                  v-model="action.enableCustomTemplateEmail"
                />
                <label
                  class="custom-control-label"
                  for="switch-template-email-custom"
                  >{{ $t('newAction.stepOne.labels.able') }}</label
                >
              </div>
            </div>

            <input
              type="text"
              class="form-control input-panel"
              :value="`${this.$t('newAction.stepOne.closingMessageInput')}`"
              disabled
            />

            <div class="row custom-switch" style="padding-left: 35px">
              <div class="col-12">
                <input
                  type="checkbox"
                  class="custom-control-input"
                  id="switch-final-message"
                  v-model="action.closingMessageEnabled"
                />
                <label
                  class="custom-control-label"
                  for="switch-final-message"
                  >{{ $t('newAction.stepOne.labels.able') }}</label
                >
              </div>
            </div>

            <input
              v-if="action.channel === 'email' || action.channel === 'emailsms' || action.channel === 'email/whatsapp'"
              type="text"
              class="form-control input-panel"
              :value="`${$t(
                'actionTranslateUpdate.templateTranslateRef.automaticAnswer',
              )}`"
              disabled
            />
            <div
              v-if="action.channel === 'email' || action.channel === 'emailsms' || action.channel === 'email/whatsapp'"
              class="row custom-switch"
              style="padding-left: 35px"
            >
              <div class="col-12">
                <input
                  type="checkbox"
                  class="custom-control-input"
                  id="switch-automatic-answer"
                  v-model="action.automaticAnswerEnabled"
                />
                <label
                  class="custom-control-label"
                  for="switch-automatic-answer"
                  >{{ $t('newAction.stepOne.labels.able') }}</label
                >
              </div>
            </div>

            <input
              type="text"
              class="form-control input-panel"
              :value="`${this.$t('newAction.stepOne.privacyPolicyInput')}`"
              disabled
            />

            <div class="row custom-switch" style="padding-left: 35px">
              <div class="col-12">
                <input
                  @click="activeDisclaimer"
                  type="checkbox"
                  class="custom-control-input"
                  id="switch-disclaimer"
                  v-model="disclaimer"
                />
                <label class="custom-control-label" for="switch-disclaimer">{{
                  $t('newAction.stepOne.labels.able')
                }}</label>
              </div>
            </div>

            <input
              type="text"
              class="form-control input-panel"
              :value="`${this.$t('newAction.stepOne.anonymousResponseInput')}`"
              disabled
            />

            <div class="row custom-switch" style="padding-left: 35px">
              <div class="col-12">
                <input
                  @click="activeAnonymous"
                  type="checkbox"
                  class="custom-control-input"
                  id="switch-anonymous-answer"
                  v-model="anonymous"
                />
                <label
                  class="custom-control-label"
                  for="switch-anonymous-answer"
                >
                  {{ $t('newAction.stepOne.anonymousSwitch') }}</label
                >
              </div>
              <div class="col-12">
                <input
                  @click="activeAlwaysAnonymous"
                  type="checkbox"
                  class="custom-control-input"
                  id="switch-always-anonymous-answer"
                  v-model="allAnswersAnonymous"
                />
                <label
                  class="custom-control-label"
                  for="switch-always-anonymous-answer"
                >
                  {{ $t('newAction.stepOne.alwaysAnonymousSwitch') }}</label
                >
              </div>
            </div>

            <template v-if="action.channel !== 'qrcode'">
              <input
                type="text"
                class="form-control input-panel"
                :value="`${this.$t('newAction.stepOne.footerInput')}`"
                disabled
              />
              <div class="row custom-switch" style="padding-left: 35px">
                <div class="col-12">
                  <input
                    type="checkbox"
                    class="custom-control-input"
                    id="switch-action-footer"
                    v-model="action.footerEnabled"
                  />
                  <label
                    class="custom-control-label"
                    for="switch-action-footer"
                  >
                    {{ $t('newAction.stepOne.labels.able') }}
                  </label>
                </div>
              </div>
            </template>
            <input
              v-if="action.channel !== 'widget'"
              type="text"
              class="form-control input-panel"
              :value="`${$t(
                'actionTranslateUpdate.templateTranslateRef.showIndecxLogo',
              )}`"
              disabled
            />
            <div
              v-if="action.channel !== 'widget'"
              class="row custom-switch"
              style="padding-left: 35px"
            >
              <div class="col-12">
                <input
                  type="checkbox"
                  class="custom-control-input"
                  id="switch-template-footer"
                  v-model="action.email.template.footer"
                />
                <label
                  class="custom-control-label"
                  for="switch-template-footer"
                >
                  {{ $t('newAction.stepOne.labels.able') }}
                </label>
              </div>
              <!-- <b-alert
                style="
                  font-size: 0.7em;
                  position: absolute;
                  left: 0;
                  background-color: transparent;
                  border: none;
                  padding: 0 10px 0 30px;
                "
                :show="dismissCountDown"
                variant="danger"
                @dismissed="
                  (dismissCountDown = 0), (action.email.template.footer = true)
                "
                @dismiss-count-down="countDownChanged"
              >
                Ops! Antes faça upgrade na plataforma. Voltando ao normal em
                {{ dismissCountDown }} segundos...
              </b-alert> -->
            </div>

            <input
              type="text"
              class="form-control input-panel"
              :value="`${$t(
                'actionTranslateUpdate.templateTranslateRef.noteRef',
              )}`"
              disabled
            />

            <div
              class="row custom-switch"
              style="padding-left: 35px"
            >
              <div class="col-12">
                <input
                  type="checkbox"
                  class="custom-control-input"
                  id="switch-template-ref"
                  v-model="action.refNoteEnabled"
                />
                <label class="custom-control-label" for="switch-template-ref">
                  {{ $t('newAction.stepOne.labels.able') }}
                </label>
              </div>
            </div>

            <template v-if="action.refNoteEnabled">
              <div class="row">
                <div v-if="country === 'br'" class="row">
                  <div class="col-6">
                    <input
                      type="text"
                      class="form-control"
                      style="margin-top: 15px"
                      placeholder="Ex: Improvável"
                      v-model="action.email.template.refTextLeft"
                    />
                  </div>
                  <div class="col-6">
                    <input
                      type="text"
                      class="form-control"
                      style="margin-top: 15px"
                      placeholder="Ex: Muito provável"
                      v-model="action.email.template.refTextRight"
                    />
                  </div>
                </div>
                <div v-if="country === 'us'" class="row">
                  <div class="col-6">
                    <input
                      type="text"
                      class="form-control"
                      style="margin-top: 15px"
                      placeholder="Ex: Improvável"
                      v-model="action.email.template.refTextLeftEn"
                    />
                  </div>
                  <div class="col-6">
                    <input
                      type="text"
                      class="form-control"
                      style="margin-top: 15px"
                      placeholder="Ex: Muito provável"
                      v-model="action.email.template.refTextRightEn"
                    />
                  </div>
                </div>
                <div v-if="country === 'es'" class="row">
                  <div class="col-6">
                    <input
                      type="text"
                      class="form-control"
                      style="margin-top: 15px"
                      placeholder="Ex: Improvável"
                      v-model="action.email.template.refTextLeftEs"
                    />
                  </div>
                  <div class="col-6">
                    <input
                      type="text"
                      class="form-control"
                      style="margin-top: 15px"
                      placeholder="Ex: Muito provável"
                      v-model="action.email.template.refTextRightEs"
                    />
                  </div>
                </div>
              </div>
            </template>

            <input
              v-if="
                (action.channel !== 'widget' &&
                  action.multiLanguage &&
                  action.channel == 'email') ||
                action.channel == 'emailsms' ||
                action.channel == 'link' ||
                action.channel == 'qrcode' ||
                action.channel == 'whatsapp' ||
                action.channel === 'email/whatsapp'
              "
              type="text"
              class="form-control input-panel"
              value="Habilitar tradução"
              disabled
            />

            <div
              v-if="
                (action.channel !== 'widget' &&
                  action.multiLanguage &&
                  action.channel == 'email') ||
                action.channel == 'emailsms' ||
                action.channel == 'link' ||
                action.channel == 'qrcode' ||
                action.channel == 'whatsapp' ||
                action.channel === 'email/whatsapp'
              "
              class="row custom-switch"
              style="padding-left: 35px"
            >
              <div class="col-12">
                <input
                  type="checkbox"
                  class="custom-control-input"
                  id="switch-enable-translation"
                  v-model="action.enableTranslation"
                />
                <label
                  class="custom-control-label"
                  for="switch-enable-translation"
                >
                  {{ $t('newAction.stepOne.labels.able') }}
                </label>
              </div>
            </div>

            <template v-if="action.enableTranslation && action.multiLanguage">
              <div v-if="action.channel !== 'widget'" class="row">
                <div>
                  <p>
                    Selecione o idioma do template configurado e clique em
                    salvar
                  </p>

                  <b-dropdown id="select-language">
                    <template slot="button-content">
                      <country-flag :country="country" size="normal" />
                      {{ countryName }}
                    </template>

                    <b-dropdown-item @click="selectCountry('Português')">
                      <country-flag country="br" size="normal" />
                      {{ this.$t('dashboard.portugues') }}
                    </b-dropdown-item>

                    <b-dropdown-item @click="selectCountry('English')">
                      <country-flag country="us" size="normal" />
                      {{ this.$t('dashboard.ingles') }}
                    </b-dropdown-item>

                    <b-dropdown-item @click="selectCountry('Español')">
                      <country-flag country="es" size="normal" />
                      {{ this.$t('dashboard.espanhol') }}
                    </b-dropdown-item>
                  </b-dropdown>

                  <button
                    style="border: none; background: #fff"
                    @click="saveTemplateTranslation(countryName)"
                  >
                    <i class="fas fa-save"></i>
                  </button>

                  <p>Templates traduzidos salvos</p>

                  <div class="tag" v-if="action.email.template.enableMyHTMLPt">
                    <span> Tradução: Português </span>
                    <span @click="removeTemplate('pt')" class="remove">
                      &times;
                    </span>
                  </div>

                  <div class="tag" v-if="action.email.template.enableMyHTMLEn">
                    <span> Tradução: Inglês </span>
                    <span @click="removeTemplate('en')" class="remove">
                      &times;
                    </span>
                  </div>

                  <div class="tag" v-if="action.email.template.enableMyHTMLEs">
                    <span> Tradução: Espanhol </span>
                    <span @click="removeTemplate('es')" class="remove">
                      &times;
                    </span>
                  </div>
                </div>
              </div>
            </template>

            <input
              v-if="action.channel !== 'widget'"
              type="text"
              class="form-control input-panel"
              :value="`${$t(
                'actionTranslateUpdate.templateTranslateRef.customSubmitButton',
              )}`"
              disabled
            />

            <div
              v-if="action.channel !== 'widget'"
              class="row custom-switch"
              style="padding-left: 35px"
            >
              <div class="col-12">
                <input
                  type="checkbox"
                  class="custom-control-input"
                  id="switch-template-submit"
                  v-model="action.submitButtonEnabled"
                />
                <label
                  class="custom-control-label"
                  for="switch-template-submit"
                >
                  {{ $t('newAction.stepOne.labels.able') }}
                </label>
              </div>
            </div>
            <template v-if="action.submitButtonEnabled">
              <div class="space-to-see">
                <div v-if="action.channel !== 'widget'" class="col">
                  <input
                    v-show="country === 'br'"
                    type="text"
                    class="form-control"
                    style="margin-top: 15px"
                    placeholder="Texto do botão enviar"
                    v-model="submitButtonValue"
                  />
                  <input
                    v-show="country === 'us'"
                    type="text"
                    class="form-control"
                    style="margin-top: 15px"
                    placeholder="Texto do botão enviar"
                    v-model="submitButtonValueEn"
                  />
                  <input
                    v-show="country === 'es'"
                    type="text"
                    class="form-control"
                    style="margin-top: 15px"
                    placeholder="Texto do botão enviar"
                    v-model="submitButtonValueEs"
                  />
                  <br />

                  <div style="display: flex">
                    <div style="display: flex; justify-content: space-around">
                      <button
                        type="button"
                        :style="{
                          marginRight: '15px',
                          boxShadow: `0px 10px 30px -7px ${buttonColor}`,
                          backgroundColor: buttonColor,
                          borderColor: buttonBorderColor,
                          color: buttonTextColor,
                        }"
                        class="btn btn-primary px-5 py-2 btn-shadow"
                      >
                        <span v-show="country === 'br'">
                          {{
                            submitButtonValue
                              ? submitButtonValue
                              : $t('previewPage.send')
                          }}
                        </span>
                        <span v-show="country === 'us'">
                          {{
                            submitButtonValueEn
                              ? submitButtonValueEn
                              : $t('previewPage.send')
                          }}
                        </span>
                        <span v-show="country === 'es'">
                          {{
                            submitButtonValueEs
                              ? submitButtonValueEs
                              : $t('previewPage.send')
                          }}
                        </span>
                      </button>
                      <label for="pickScaleButton" class="scaleLabel">
                        {{ $t('newAction.stepOne.scaleButton') }}:
                      </label>
                      <verte
                        ref="pickScaleButton"
                        picker="square"
                        model="hex"
                        v-model="buttonColor"
                      >
                      </verte>
                    </div>
                    <div style="display: flex; padding-left: 20px">
                      <label for="pickBorderButton" class="scaleLabel">
                        {{ $t('newAction.stepOne.scaleBorder') }}:
                      </label>
                      <verte
                        ref="pickBorderButton"
                        picker="square"
                        model="hex"
                        v-model="buttonBorderColor"
                      >
                      </verte>
                    </div>
                    <div style="display: flex; padding-left: 20px">
                      <label for="pickButtonTextColor" class="scaleLabel">
                        {{ $t('newAction.stepOne.scaleGrade') }}:
                      </label>
                      <verte
                        ref="pickButtonTextColor"
                        picker="square"
                        model="hex"
                        v-model="buttonTextColor"
                      >
                      </verte>
                    </div>
                    <br />
                  </div>
                </div>
              </div>
              <p></p>
            </template>
          </div>
        </transition>
      </div>
    </div>
    <div v-else class="text-center">
      <b-spinner
        variant="success"
        type="grow"
        label="Spinning"
        class="bg-primary"
      ></b-spinner>
    </div>
  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex';
import CountryFlag from 'vue-country-flag';
import $ from 'jquery';
import iconv from 'iconv-lite';
import swal from 'sweetalert';
import Verte from 'verte';
import 'verte/dist/verte.css';
import cSat from '@/components/molecules/metrics/csat';
import likert from '@/components/molecules/metrics/likert';
import starRating from '@/components/molecules/metrics/reviews';
import likeDislike from '@/components/molecules/metrics/like-dislike';
import emotion from '@/components/molecules/metrics/emotion';
import buttonsTemplates from '../btn-templates';
import scaleLayoutOptions from '../scale-layout-options';
import modalTestSurveyEmail from '../../../molecules/modal-test-survey-email';
import fileInput from '../file-input';
import methodology from '../methodology';
import EventBus from '../../../../eventBus';

export default {
  name: 'TemplateEmail',

  components: {
    buttonsTemplates,
    scaleLayoutOptions,
    fileInput,
    methodology,
    cSat,
    likert,
    starRating,
    likeDislike,
    emotion,
    modalTestSurveyEmail,
    Verte,
    CountryFlag,
  },

  data: () => ({
    loading: false,
    anonymous: false,
    allAnswersAnonymous: false,
    show_editor: true,
    doShow: false,
    larguePanel: null,
    logo: null,
    uploadedImageURL: null,
    apiRoot: null,
    preview: false,
    showDismissibleAlert: false,
    template: '0',
    templateName: null,
    disclaimer: false,
    userAuth: null,
    panelLeft: 'col-11',
    panelRight: 'col-1',
    comeBackPanel: 'col-12',
    showReturn: false,
    panelOptions: false,
    dismissSecs: 5,
    dismissCountDown: 0,
    noEditor: true,
    templateColorSelected: 'colors',
    templatescale: '#ffffff',
    templateborder: '#ffffff',
    templategrade: '#ffffff',
    templatebutton: '#ffffff',
    templatebackground: '#ffffff',
    templatebackgroundtext: '#000000',
    templatebuttonselected: '#ffffff',
    templatebuttonselectedtext: '#ffffff',
    buttonColor: '#4ce595',
    buttonTextColor: '#ffffff',
    buttonBorderColor: '#4ce595',
    options: [
      { text: 'Padrão', value: 'colors' },
      { text: 'Custom', value: 'custom' },
    ],
    linkprivacyPolicy: null,
    showPen: true,
    questionHTML: null,
    questionHTMLEn: null,
    questionHTMLEs: null,
    footerContent: null,
    footerContentEn: null,
    footerContentEs: null,
    submitButtonValue: null,
    submitButtonValueEn: null,
    submitButtonValueEs: null,
    refTextLeft: null,
    refTextLeftEn: null,
    refTextLeftEs: null,
    refTextRight: null,
    refTextRightEn: null,
    refTextRightEs: null,
    privacyPolicy: 'Link para Política de Privacidade',
    privacyPolicyEn: 'Privacy Policy URL',
    privacyPolicyEs: 'Link para Política de Privacidad',
    countryName: 'Português',
    country: 'br',
    translateTemplate: {
      enableMyHTMLPt: false,
      enableMyHTMLEs: false,
      enableMyHTMLEn: false,
    },
  }),

  watch: {
    questionHTML: function watchQuestionHTML(value) {
      this.action.questionHTML = `<div>${value}</div>`;
      // convert iso to utf8
      const theTextinHex = iconv.decode(this.action.questionHTML, 'iso88591');
      const question = $(this.action.questionHTML).html(theTextinHex).text();
      this.action.question = question.trim();
    },

    questionHTMLEn: function watchQuestionHTMLEn(value) {
      this.action.questionHTMLEn = `${value}`;
      // convert iso to utf8
      const theTextinHex = iconv.decode(this.action.questionHTMLEn, 'iso88591');
      const question = $(this.action.questionHTMLEn).html(theTextinHex).text();
      this.action.questionEn = question.trim();
    },

    questionHTMLEs: function watchQuestionHTMLEs(value) {
      this.action.questionHTMLEs = `${value}`;
      // convert iso to utf8
      const theTextinHex = iconv.decode(this.action.questionHTMLEs, 'iso88591');
      const question = $(this.action.questionHTMLEs).html(theTextinHex).text();
      this.action.questionEs = question.trim();
    },

    templateColorSelected: function watchTemplateColorSelected(value) {
      this.setScaleColors(value);
      this.setScaleColorsAction(value);
    },

    buttonColor: function watchButtonColor(value) {
      if (value !== 'colors' && value !== 'fixedColors') {
        this.action.email.template.buttonColor = value;
        this.$store.state.templates.list[1].buttonColor = value;
      }
    },

    buttonTextColor: function watchButtonTextColor(value) {
      if (value !== 'colors' && value !== 'fixedColors') {
        this.action.email.template.buttonTextColor = value;
        this.$store.state.templates.list[1].buttonTextColor = value;
      }
    },

    buttonBorderColor: function watchButtonBorderColor(value) {
      if (value !== 'colors' && value !== 'fixedColors') {
        this.action.email.template.buttonBorderColor = value;
        this.$store.state.templates.list[1].buttonBorderColor = value;
      }
    },

    submitButtonValue: function watchsubmitButtonValue() {
      this.action.email.template.submitButtonValue = this.submitButtonValue;
    },

    submitButtonValueEn: function watchsubmitButtonValueEn() {
      this.action.email.template.submitButtonValueEn = this.submitButtonValueEn;
    },

    submitButtonValueEs: function watchsubmitButtonValueEs() {
      this.action.email.template.submitButtonValueEs = this.submitButtonValueEs;
    },

    templatescale: function watchTemplatescale(value) {
      if (value !== 'colors' && value !== 'fixedColors') {
        this.action.email.template.scale = value;
        this.$store.state.templates.list[1].scale = value;
      }
    },

    templateborder: function watchTemplateborder(value) {
      if (value !== 'colors' && value !== 'fixedColors') {
        this.action.email.template.border = value;
        this.$store.state.templates.list[1].border = value;
      }
    },

    templategrade: function watchTemplategrade(value) {
      if (value !== 'colors' && value !== 'fixedColors') {
        this.action.email.template.grade = value;
        this.$store.state.templates.list[1].grade = value;
        this.$store.state.templates.list[0].grade = value;
      }
    },

    templatebutton: function watchTemplatebutton(value) {
      this.action.email.template.button = value;
      this.$store.state.templates.list[1].button = value;
    },

    templatebackground: function watchTemplatebackground(value) {
      this.action.email.template.background = value;
      this.$store.state.templates.list[1].background = value;
    },

    templatebackgroundtext: function watchTemplatebackgroundtext(value) {
      this.action.email.template.backgroundtext = value;
      this.$store.state.templates.list[1].backgroundtext = value;
    },

    templatebuttonselected: function watchTemplatebuttonSelected(value) {
      if (value !== 'colors' && value !== 'fixedColors') {
        this.action.email.template.templatebuttonselected = value;
        this.$store.state.templates.list[1].templatebuttonselected = value;
      }
    },

    templatebuttonselectedtext: function watchTemplatebuttonSelectedText(
      value,
    ) {
      if (value !== 'colors' && value !== 'fixedColors') {
        this.action.email.template.templatebuttonselectedtext = value;
        this.$store.state.templates.list[1].templatebuttonselectedtext = value;
      }
    },

    'action.email.template.footer': function watchFooter() {
      this.showAlert();
    },

    'action.uploadedImage': function watchActionImage(image) {
      this.uploadedImageURL = image;
    },

    'action.useLogo': function watchUseLogo(value) {
      if (value) {
        const logoUrl = process.env.INDECX_FILES_BUCKET;
        this.logo = `${logoUrl}/${this.company.logo}`;
      } else {
        this.setActionImage(null);
        this.action.logo = null;
      }
    },

    'action.submitButtonEnabled': function watchButtonEnabled(buttonEnabled) {
      if (buttonEnabled === true) {
        this.action.submitButtonEnabled = buttonEnabled;
      } else {
        this.action.submitButtonEnabled = buttonEnabled;
        this.buttonColor = '#4ce595';
        this.buttonTextColor = '#ffffff';
        this.buttonBorderColor = '#4ce595';
      }
    },

    'action.refNoteEnabled': function watchRefNoteEnabled(buttonEnabled) {
      if (buttonEnabled === true) {
        this.action.refNoteEnabled = buttonEnabled;
      } else {
        this.action.email.template.refTextLeft = null;
        this.action.email.template.refTextRight = null;
        this.action.email.template.refTextLeftEn = null;
        this.action.email.template.refTextRightEn = null;
        this.action.email.template.refTextLeftEs = null;
        this.action.email.template.refTextRightEs = null;
        this.action.refNoteEnabled = buttonEnabled;
      }
    },

    '$i18n.locale': function watchLocale() {
      this.updateHTMLTemplate();
    },
  },

  computed: {
    ...mapState('actions', ['action', 'isEditAction', 'closingMessage']),
    ...mapState('templates', ['list', 'templateSelected']),
    ...mapState('settings', ['showModal']),
    ...mapState('companies', ['company']),
  },

  methods: {
    removeTemplate(language) {
      if (language === 'pt') {
        this.action.email.template.enableMyHTMLPt = false;
      } else if (language === 'en') {
        this.action.email.template.enableMyHTMLEn = false;
      } else {
        this.action.email.template.enableMyHTMLEs = false;
      }
    },

    saveTemplateTranslation(country) {
      if (country === 'Português') {
        this.action.questionHTML = this.questionHTML;
        this.action.footerContent = this.footerContent;
        this.action.email.template.submitButtonValue = this.submitButtonValue;
        // this.action.email.template.refTextLeft = this.refTextLeft;
        // this.action.email.template.refTextRight = this.refTextRight;
        this.action.email.template.enableMyHTMLPt = true;
        this.translateTemplate.enableMyHTMLPt = true;
      } else if (country === 'English') {
        this.action.questionHTMLEn = this.questionHTMLEn;
        this.action.footerContentEn = this.footerContentEn;
        this.action.email.template.submitButtonValueEn =
          this.submitButtonValueEn;
        // this.action.email.template.refTextLeftEn = this.refTextLeftEn;
        // this.action.email.template.refTextRightEn = this.refTextRightEn;
        this.action.email.template.enableMyHTMLEn = true;
        this.translateTemplate.enableMyHTMLEn = true;
      } else {
        this.action.questionHTMLEs = this.questionHTMLEs;
        this.action.footerContentEs = this.footerContentEs;
        this.action.email.template.submitButtonValueEs =
          this.submitButtonValueEs;
        // this.action.email.template.refTextLeftEs = this.refTextLeftEs;
        // this.action.email.template.refTextRightEs = this.refTextRightEs;
        this.action.email.template.enableMyHTMLEs = true;
        this.translateTemplate.enableMyHTMLEs = true;
      }

      this.action.email.template = {
        ...this.action.email.template,
        ...this.template,
      };

      if (this.company.privacyPolicy) {
        this.action.privacyPolicy = `${this.privacyPolicy} ${this.company.name}`;
        this.action.privacyPolicyEn = `${this.privacyPolicyEn} ${this.company.name}`;
        this.action.privacyPolicyEs = `${this.privacyPolicyEs} ${this.company.name}`;
      }
    },

    async selectCountry(country) {
      if (country === 'Português') {
        this.countryName = country;
        this.country = 'br';
      } else if (country === 'English') {
        this.countryName = country;
        this.country = 'us';
      } else {
        this.countryName = country;
        this.country = 'es';
      }

      return this.country;
    },

    shown() {
      this.doShow = true;
    },

    updateHTMLTemplate() {
      if (!this.action._id) {
        this.action.email.template.myHTML = this.$t('newAction.templateHTML');
      }
    },

    hide() {
      this.doShow = false;
    },

    showEditor() {
      $(document).on('focusin', function focusEditor(e) {
        if (
          $(e.target).closest(
            '.tox-tinymce-aux, .tox-dialog, .moxman-window, .tam-assetmanager-root',
          ).length
        ) {
          e.stopImmediatePropagation();
        }
      });
    },

    uploadImgTinyMce(cb) {
      const $input = document.createElement('input');
      $input.setAttribute('type', 'file');
      $input.setAttribute('accept', 'image/*');
      // this.uploadedImageURL = this.image;
      $input.onchange = function onChangeImg() {
        const file = this.files[0];
        const reader = new FileReader();
        reader.onload = function readerImg() {
          const id = `blobid${new Date().getTime()}`;
          const blobCache = window.tinymce.activeEditor.editorUpload.blobCache;
          const base64 = reader.result.split(',')[1];
          const blobInfo = blobCache.create(id, file, base64);
          blobCache.add(blobInfo);
          cb(blobInfo.blobUri(), { title: file.name });
        };
        reader.readAsDataURL(file);
      };
      $input.click();
    },

    activeAnonymous(event) {
      if (event.target.checked) {
        this.action.allAnswersAnonymous = false;
        this.allAnswersAnonymous = false;
        this.action.enableAnonymous = 'Quero responder de forma anônima';
        this.action.enableAnonymousEn = 'I want to answer anonymously';
        this.action.enableAnonymousEs = 'Quiero responder de forma anonima';
      } else {
        this.anonymous = false;
        this.action.enableAnonymous = null;
      }
    },

    activeAlwaysAnonymous(event) {
      if (event.target.checked) {
        this.anonymous = false;
        this.action.enableAnonymous = 'Resposta anônima';
        this.action.enableAnonymousEn = 'Anonymous answer';
        this.action.enableAnonymousEs = 'Respuesta anónima';
        this.action.allAnswersAnonymous = true;
        this.allAnswersAnonymous = true;
      } else {
        this.allAnswersAnonymous = false;
        this.action.allAnswersAnonymous = false;
      }
    },

    activeDisclaimer(event) {
      if (event.target.checked) {
        if (this.company.privacyPolicy) {
          this.action.privacyPolicy = `${this.privacyPolicy} ${this.company.name}`;
          this.action.privacyPolicyEn = `${this.privacyPolicyEn} ${this.company.name}`;
          this.action.privacyPolicyEs = `${this.privacyPolicyEs} ${this.company.name}`;
        } else {
          this.disclaimer = false;
          swal({
            title: this.$t('newAction.stepOne.messageError.title'),
            text: this.$t('newAction.stepOne.messageError.description'),
            icon: 'error',
          });
        }
      } else {
        this.action.privacyPolicy = null;
        this.action.privacyPolicyEn = null;
        this.action.privacyPolicyEs = null;
      }
    },

    modifyTemplate() {
      if (this.template !== '0') {
        this.setTemplate({
          id: this.template,
          token: this.userAuth.token,
          companyId: this.userAuth.companyId,
        }).then(() => {
          this.setBodyEmail(this.templateSelected.body);
        });
      }
    },

    saveTemplate() {
      if (!this.templateName || this.templateName === '') {
        const $el = document.getElementById('inline-form-input-template-name');
        $el.classList.add('is-invalid');
      } else {
        this.storeTemplate({
          data: {
            body: this.action.email.template.myHTML,
            companyId: this.userAuth.companyId,
            title: this.templateName,
            scale: this.templateColorSelected,
          },
          token: this.userAuth.token,
        }).then(() => {
          this.templateName = null;
          this.showDismissibleAlert = true;
          this.setList({
            companyId: this.userAuth.companyId,
            token: this.userAuth.token,
          });
        });
      }
    },

    showAlert() {
      this.dismissCountDown = this.dismissSecs;
    },

    countDownChanged(dismissCountDown) {
      this.dismissCountDown = dismissCountDown;
    },

    ...mapActions('actions', [
      'setEmailFrom',
      'setEmailSubject',
      'setBodyEmail',
      'setScaleColorsAction',
      'setActionImage',
    ]),
    ...mapActions('templates', [
      'setList',
      'storeTemplate',
      'setTemplate',
      'setScaleColors',
    ]),
    ...mapActions('companies', ['getCompany']),

    returnPanel() {
      this.panelLeft = 'col-10';
      this.panelRight = 'col-2';
      this.panelOptions = false;
      this.noEditor = true;
      this.showReturn = false;
      this.showPen = true;
      EventBus.$emit('returnPosition', this.comeBackPanel);
      document.getElementById('config-template').style.backgroundColor = '#fff';
    },

    expandPanel() {
      // if (this.panelRight === 'col-1') {
      this.panelLeft = 'col-8';
      this.panelRight = 'col-4';
      this.larguePanel = 'col-12';
      this.panelOptions = true;
      this.noEditor = false;
      this.showReturn = true;
      this.showPen = false;
      EventBus.$emit('editorPosition', this.larguePanel);
      document.getElementById('config-template').style.backgroundColor = '#fff';
      // }
      // else {
      //   this.panelLeft = 'col-8';
      //   this.panelRight = 'col-4';
      //   this.larguePanel = 'col-12';
      //   this.panelOptions = true;
      //   this.noEditor = false;
      //   this.showReturn = true;
      //   this.showPen = false;
      //   EventBus.$emit('editorPosition', this.larguePanel);
      //   document.getElementById('config-template').style.backgroundColor =
      //     '#fff';
      // }
    },

    checkPreview() {
      if (this.isEditAction) {
        localStorage.setItem(
          'is_edit_action',
          JSON.stringify({ isEditAction: true }),
        );
      }
      localStorage.setItem('_indecx_action', JSON.stringify(this.action));

      localStorage.setItem(
        '_indecx_action_closing_message',
        JSON.stringify(this.closingMessage),
      );
    },

    imagesUploadHandlerBody(blobInfo, success, failure) {
      if (blobInfo) {
        const xhr = new XMLHttpRequest();

        xhr.withCredentials = false;
        xhr.open('POST', `${process.env.API_ROOT}/image-body/action`);
        xhr.setRequestHeader('x-access-token', this.userAuth.token);
        xhr.onload = function analise() {
          if (xhr.status !== 200) {
            failure(`HTTP Error: ${xhr.status}`);
            return;
          }
          const json = JSON.parse(xhr.responseText);
          if (!json || typeof json !== 'string') {
            failure(`Invalid JSON: ${xhr.responseText}`);
            return;
          }
          success(json);
        };
        const formData = new FormData();
        formData.append('file', blobInfo.blob(), blobInfo.filename());
        xhr.send(formData);
      }
    },

    imagesUploadHandlerFooter(blobInfo, success, failure) {
      if (blobInfo) {
        const xhr = new XMLHttpRequest();

        xhr.withCredentials = false;
        xhr.open('POST', `${process.env.API_ROOT}/image-footer/action`);
        xhr.setRequestHeader('x-access-token', this.userAuth.token);
        xhr.onload = function analise() {
          if (xhr.status !== 200) {
            failure(`HTTP Error: ${xhr.status}`);
            return;
          }
          const json = JSON.parse(xhr.responseText);

          if (!json || typeof json !== 'string') {
            failure(`Invalid JSON: ${xhr.responseText}`);
            return;
          }
          success(json);
        };

        const formData = new FormData();
        formData.append('file', blobInfo.blob(), blobInfo.filename());
        xhr.send(formData);
      }
    },
  },

  async created() {
    this.userAuth = JSON.parse(localStorage.getItem('_indecx'));
    this.imagesUploadHandlerFooter();
    this.imagesUploadHandlerBody();
    this.updateHTMLTemplate();

    // if (this.action.questionHTML) {
    //   this.questionHTML = this.action.questionHTML;
    // } else {
    //   this.questionHTML = this.action.question;
    // }

    if (this.action.questionHTML) {
      this.questionHTML = this.action.questionHTML;
    } else {
      this.questionHTML = this.action.question;
    }
    if (this.action.questionHTMLEn) {
      this.questionHTMLEn = this.action.questionHTMLEn || '';
    } else {
      this.questionHTMLEn = this.action.questionEn || '';
    }
    if (this.action.questionHTMLEs) {
      this.questionHTMLEs = this.action.questionHTMLEs || '';
    } else {
      this.questionHTMLEs = this.action.questionEs || '';
    }
  },

  async mounted() {
    this.loading = true;
    this.apiRoot = process.env.API_ROOT;
    this.loading = true;

    const logoUrl = process.env.INDECX_FILES_BUCKET;

    await this.getCompany({
      id: this.userAuth.companyId,
      token: this.userAuth.token,
    });
    if (this.action.useLogo) {
      if (this.action.uploadedImage) {
        this.logo = this.action.uploadedImage;
      } else if (this.action.logo) {
        this.logo = `${logoUrl}/${this.action.logo}`;
      } else {
        this.logo = `${logoUrl}/${this.company.logo}`;
      }
    }
    if (this.action.privacyPolicy) {
      this.disclaimer = true;
      this.linkprivacyPolicy = `${process.env.INDECX_FILES_BUCKET}/privacy-policy/${this.company.privacyPolicy}`;
    }
    if (!this.action._id) {
      this.action.enableAnonymous = null;
      this.action.alwaysEnableAnonymous = null;
    }
    if (this.$route.params.enableAnonymous) {
      this.anonymous = true;
      this.action.enableAnonymous = this.$route.params.enableAnonymous;
    }
    if (this.action.enableAnonymous) {
      this.anonymous = true;
    }
    this.allAnswersAnonymous = this.action.allAnswersAnonymous ? true : false;
    if (this.allAnswersAnonymous) {
      this.anonymous = null;
    }
    this.templatescale = this.action.email.template.scale;
    this.templateborder = this.action.email.template.border;
    this.templategrade = this.action.email.template.grade;
    this.templatebutton = this.action.email.template.button;
    this.templatebackground = this.action.email.template.background;
    this.templatebackgroundtext = this.action.email.template.backgroundtext;
    this.buttonColor = this.action.email.template.buttonColor || '#4ce595';
    this.templatebuttonselected =
      this.action.email.template.templatebuttonselected;
    this.templatebuttonselectedtext =
      this.action.email.template.templatebuttonselectedtext;
    this.buttonTextColor =
      this.action.email.template.buttonTextColor || '#ffffff';
    this.buttonBorderColor =
      this.action.email.template.buttonBorderColor || '#4ce595';
    this.loading = false;
    this.footerContent = this.action.footerContent;
    this.footerContentEn = this.action.footerContentEn;
    this.footerContentEs = this.action.footerContentEs;
    this.submitButtonValue = this.action.email.template.submitButtonValue;
    this.submitButtonValueEn = this.action.email.template.submitButtonValueEn;
    this.submitButtonValueEs = this.action.email.template.submitButtonValueEs;

    this.refTextLeft = this.action.email.template.refTextLeft || 'Improvável';
    this.refTextRight =
      this.action.email.template.refTextRight || 'Muito provável';

    this.refTextLeftEn = this.action.email.template.refTextLeftEn || 'Unlikely';
    this.refTextRightEn =
      this.action.email.template.refTextRightEn || 'Very likely';

    this.refTextLeftEs =
      this.action.email.template.refTextLeftEs || 'Improbable';
    this.refTextRightEs =
      this.action.email.template.refTextRightEs || 'Muy probable';
    if (this.action.multiLanguage) {
      this.action.enableTranslation = true;
    }

    EventBus.$on('custom', () => {
      this.templatescale = '#ffffff';
      this.templatebuttonselected = '#cccccc';
      this.templateborder = '#888888';
      this.templategrade = '#000000';
      this.templatebutton = '#888888';
      this.templatebackground = '#ffffff';
      this.templatebackgroundtext = '#000000';
      this.templatebuttonselectedtext = '#ffffff';
      this.buttonColor = '#4ce595';
      this.buttonTextColor = '#888888';
      this.buttonBorderColor = '#4ce595';
    });
  },
};
</script>

<style lang="scss" scoped>
@import '@/themes/default/variables.scss';
@import url('https://fonts.googleapis.com/css2?family=Lato:wght@400;700;900&display=swap');
.tag {
  background: $primary;
  padding: 4px 8px;
  color: $white;
  border-radius: 8px;
  margin-right: 8px;
  width: 200px;
  margin-top: 5px;

  .remove {
    cursor: pointer;
  }
}

.row {
  padding: 0 14px;
}
.panel-template {
  transition: all 0.2s linear;
  padding: 0 30px 0 0;
  > div {
    margin-top: 10px;
    &:first-of-type {
      margin-top: 0;
    }
  }
  .template-header {
    border: 1px dashed $gray;
    padding: 10px;
    text-align: center;
    img {
      height: 70px;
    }
  }
  .template-body {
    border: 1px dashed $gray;
    padding: 10px;
  }
  .template-methodology {
    border: 1px dashed $gray;
    padding: 10px;
  }
  .template-footer {
    border: 1px dashed $gray;
    padding: 10px;
    text-align: center;
    img {
      width: 80px;
    }
    p {
      margin: 0;
      padding: 0;
      font-size: 0.9em;
      margin-top: 10px;
    }
  }
  .footer-content {
    border: 1px dashed $gray;
    padding: 10px;
    height: auto;
    overflow: hidden;
  }
  .template-disclaimer {
    border: 1px dashed $gray;
    font-size: 0.9em;
    padding: 10px;
    text-align: center;
    a {
      color: #212529;
    }
  }
}
.config-template {
  transition: all 0.2s linear;
  padding-top: 17px;
  padding-left: 30px;
  margin-top: -17px;
  background-color: #fff;
  position: relative;
  min-height: 405px;
  .input-panel {
    background-color: transparent;
    padding: 0;
    border: none;
    font-size: 0.9em;
    margin-top: 10px;
    font-weight: bold;
    &:first-of-type {
      margin-top: 10px;
    }
  }

  .space-to-see {
    margin-top: 1rem;
  }
  .btn-actions {
    display: flex;
    flex-direction: column;
    width: 40px;
    position: absolute;
    left: -20px;
    .btn {
      margin-bottom: 5px;
      &:last-of-type {
        margin-bottom: 0;
      }
    }
    .preview {
      margin: 5px 0;
    }
  }
  .filename {
    font-size: 0.75em;
    text-align: center;
  }
  .custom-control-label {
    font-size: 0.8em;
  }
}
.template-footer-modal {
  padding: 10px;
  text-align: center;
  img {
    width: 100px;
  }
  p {
    margin: 0;
    padding: 0;
    font-size: 0.9em;
    margin-top: 10px;
  }
}
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.2s;
}
.fade-enter,
.fade-leave-to {
  opacity: 0;
}
.btn-view {
  max-width: 40px;
}
.question {
  font-size: 1.1rem;
}

.rate-experience {
  color: #fff;
  width: 50%;
  border: 0;
  height: 50px;
}

.button-experience {
  text-align: center;
  border: 1px dashed #bdbdbd;
  padding: 10px;
}

@media (max-width: 1500px) {
  .config-template {
    position: absolute;
    top: 57px;
    right: 20px;
  }
}
</style>

<style>
.no-editor img {
  max-width: 100%;
}
.verte {
  height: 25px;
}
.verte__guide {
  padding: 5px;
}
.verte__icon {
  width: 25px;
  height: 25px;
}
.scaleLabel {
  background-color: transparent;
  padding: 0;
  border: none;
  font-size: 0.9em;
  margin-top: 10px;
  font-weight: bold;
}
iframe {
  background-color: transparent !important;
  background: transparent !important;
}
</style>



// WEBPACK FOOTER //
// src/components/molecules/action-templates/email/index.vue